// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2nulg","question":"Question_question__1fZqP","description":"Question_description__2kHyM"};